import setIfExists from 'utils/set-if-exists.js';

angular
.module('inkfinder')
.factory('Collector', function Collector(
  $q,
  $rootScope,
  $state,
  $http,
  $interval,
  ENDPOINT,
  Association,
  moment,
  AlertMessages,
  Session,
  Shop,
  _
) {
  // Public functions
  Collector.refreshProfile = refreshProfile;
  Collector.updateProfile = updateProfile;
  Collector.updateCollector = updateCollector;
  Collector.searchCollectors = searchCollectors;
  Collector.createCollector = createCollector;
  Collector.getCollector = getCollector;
  Collector.getCollectors = getCollectors;

  let qwe;
  resetVariables();

/**
  * @description
  * Reset variables
  */
  function resetVariables() {
    qwe = {profile: {}};
    Collector.profile = {};
  }

/**
  * @description
  * Called to Reset Data on Logout
  */
  let deregister = $rootScope.$on('clear-data', function() {
    $interval.cancel(qwe.profile.timer);
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

/**
  * @description
  * Create a new profile timing for polling
  */
  function createProfileTimer() {
    if (!qwe.profile.timer) {
      qwe.profile.timer = $interval(makeNewProfilePromise, 1000);
    }
  }

/**
  * @description
  * make a new profile promise for caching
  */
  function makeNewProfilePromise() {
    if (!shouldRefresh()) {
      return;
    }

    qwe.profile.promise = $q(function(resolve, reject) {
      qwe.profile.refreshing = true;
      $http.get(ENDPOINT.server + 'collectors/api/v1.1/')
      .then(function(response) {
        if (qwe.profile.timer) {
          parseProfile(response.data).then(function(profile) {
            profile.messages = {};
            Collector.profile = profile;
            qwe.profile.updated = moment();
            Session.updateCollector(Collector.profile);
            resolve(Collector.profile);
          });
        }
        qwe.profile.refreshing = false;
      }, function(error) {
        reject(error);
      });
    });
  }

/**
  * @description
  * Unknown
  * @return {function} Unknown
  */
  function shouldRefresh() {
    return !qwe.profile.refreshing &&
    (!qwe.profile.updated ||
    moment().diff(qwe.profile.updated, 'seconds') >= 67);
  }

/**
  * @description
  * Unknown
  * @return {function} Unknown
  */
  function fetchProfile() {
    createProfileTimer();
    makeNewProfilePromise();
    return qwe.profile.promise;
  }

/**
  * @description
  * Unknown
  * @return {function} Unknown
  */
  function refreshProfile() {
    qwe.profile.updated = null;
    return fetchProfile();
  }

/**
  * @description
  * Unknown
  * @param {unknown} input Unknown
  * @return {function} Unknown
  */
  function updateProfile(input) {
    let profile = formatProfile(input);
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/', profile)
    .then(function(response) {
      return parseProfile(response.data).then(function(profile) {
        Collector.profile = profile;
        Session.updateCollector(profile);
        return profile;
      });
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @description
  * Unknown
  * @param {unknown} collector The collector to update
  * @return {function} Unknown
  */
  function updateCollector(collector) {
    let formattedCollector = formatProfile(collector);
    return $http.put(
    ENDPOINT.server + 'collectors/api/v1.1/', formattedCollector)
    .then(function(collector) {
      AlertMessages.add({
        msg: 'We saved this profile.',
        type: 'success'
      });
      return collector;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

/**
  * @description
  * Formats the collector object
  * @param {object} input The raw collector object
  * @return {object} The formatted collector object
  */
  function formatProfile(input) {
    let output = {};

    if (input) {
      setIfExists(input, 'id', output);
      setIfExists(input, 'username', output);
      setIfExists(input, 'first_name', output);
      setIfExists(input, 'last_name', output);
      setIfExists(input, 'phone', output);
      setIfExists(input, 'email', output);
      setIfExists(input, 'new_email', output);
      setIfExists(input, 'is_new_user', output);
      setIfExists(input, 'profile_photo', output);
      setIfExists(input, 'accepted_TOS_Privacy', output);
      setIfExists(input, 'email_is_confirmed', output);
      setIfExists(input, 'calendar_compact', output);
      setIfExists(input, 'calendar_skinny', output);
    }
    return output;
  }

/**
  * @description
  * Parse the collector object
  * @param {object} input The collector object to be parsed
  * @return {object} input returns the parsed collector object
  */
  function parseProfile(input) {
    return Association.getAssociation(input.id)
    .then(function(associations) {
      input.associations = associations;
      return input;
    });
  }

/**
  * @description
  * Search collectors
  * @param {string} query The email or phone number to search
  * @param {string} searchFields The fields to perform the search over
  * @return {object} Returns a promise object?
  */
  function searchCollectors(query, searchFields) {
    let url = ENDPOINT.server + 'collectors/api/v1.1/all/?q=' +
    query + '&searchFields=' + searchFields;
    return $http.get(url).then(function(response) {
      let parsedCollectors = response.data.map(function(collector) {
        return parseProfile(collector);
      });
      return $q.all(parsedCollectors);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

/**
  * @description
  * Create collector
  * @param {object} collector The details for the collector
  * @return {object} Returns a promise object?
  */
  function createCollector(collector) {
    let url = ENDPOINT.server + 'collectors/api/v1.1/';
    return $q(function(resolve, reject) {
      $http.post(url, collector)
      .then(function(response) {
        resolve(response.data);
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        reject(error);
      });
    });
  }

  /**
   * @description
   * Get collector
   * @param {object} id The ID of the collector to retrieve
   * @return {object} Returns a promise object?
   */
  function getCollector(id) {
    let url = ENDPOINT.server + 'collectors/api/v1.1/' + id + '/';
    return $http.get(url).then(function(response) {
      return parseProfile(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getCollectors
   * @description Function to get an array of collectors based on URL params
   * @param {object} username The username of the collector to filter by
   * @return {array} Returns an array of collectors. The array will be empty if
   * the filters exclude any results.
   */
  function getCollectors(username) {
    let url = ENDPOINT.server + 'collectors/api/v1.1/?';
    if (!_.isUndefined(username)) {
      url += 'username=' + username;
    }
    return $http.get(url)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Collector;
});



// WEBPACK FOOTER //
// ./components/collector/collector.service.js